import React, { useRef, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import Globe from "react-globe.gl";

const coloredArcsData = [
  { startLat: 40.7128, startLng: -74.006, endLat: 51.5074, endLng: -0.1278, color: ["#ff6b6b", "#4ecdc4"] },
  { startLat: 35.6762, startLng: 139.6503, endLat: 48.8566, endLng: 2.3522, color: ["#45b7d1", "#96ceb4"] },
  { startLat: -33.8688, startLng: 151.2093, endLat: 34.0522, endLng: -118.2437, color: ["#feca57", "#ff9ff3"] },
  { startLat: 39.9042, startLng: 116.4074, endLat: 55.7558, endLng: 37.6173, color: ["#54a0ff", "#5f27cd"] },
  { startLat: 19.076, startLng: 72.8777, endLat: -23.5505, endLng: -46.6333, color: ["#00d2d3", "#ff9f43"] },
  { startLat: 1.3521, startLng: 103.8198, endLat: 52.52, endLng: 13.405, color: ["#c44569", "#cf6a87"] },
];




function Home() {

// useEffect(() => {
//   // Current fix
//   document.body.style.overflowX = 'hidden';
//   document.documentElement.style.overflowX = 'hidden';
  
//   // Debugging
//   const findOverflow = () => {
//     document.querySelectorAll('*').forEach(el => {
//       if (el.offsetWidth > document.documentElement.offsetWidth) {
//         console.log('🚨 OVERFLOWING ELEMENT:', el);
//         el.style.outline = '3px solid red !important';
//       }
//     });
//   };
  
//   setTimeout(findOverflow, 100);
  
//   return () => {
//     document.body.style.overflowX = 'auto';
//     document.documentElement.style.overflowX = 'auto';
//   };
// }, []);

  
  const globeRef = useRef();

  useEffect(() => {
    if (!globeRef.current) return;
    const controls = globeRef.current.controls();
    controls.enableRotate = true;
    controls.enableZoom = true;
    controls.enablePan = false;
    controls.autoRotate = true;
    controls.autoRotateSpeed = 0.7;
    controls.update();
  }, []);

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
               Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>
              <h1 className="heading-name">
                I'M<strong className="main-name"> Attique R.</strong>
              </h1>
              <div style={{ padding: "50px", textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 10, position: "relative", zIndex: 5, maxWidth: "100%", overflow: "hidden", }}>
                <div
                  style={{
                    width: "100%",
                    maxWidth: "100%",
                    overflow: "hidden",
                    margin: "0 auto",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    pointerEvents: "auto",
                  }}
                >
                  <div style={{ width: "100%", height: "auto", maxWidth: "100%", overflow: "hidden", aspectRatio: "1/1" }}>
                    <Globe
                      ref={globeRef} // ✅ useRef ensures proper mounting
                      globeImageUrl="https://cdn.jsdelivr.net/npm/three-globe/example/img/earth-blue-marble.jpg"
                      bumpImageUrl="https://cdn.jsdelivr.net/npm/three-globe/example/img/earth-topology.png"
                      bumpScale={0.05}
                      backgroundColor="rgba(0,0,0,0)"
                      arcsData={coloredArcsData}
                      arcColor={(d) => d.color}
                      arcStroke={0.5}
                      arcDashLength={1}
                      arcDashGap={0.5}
                      arcDashAnimateTime={2000}
                      enablePointerInteraction={true} // ✅ enables zoom & drag
                      width={370}
                      height={370}
                      overflow="hidden"
                    />
                  </div>
                </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;